/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { IndyWindData, OriginType, SanctioningBodyEnum } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import { RSocketStreamBaseService } from './RSocketStreamBaseService';

class IndyWindServiceRSocket extends RSocketStreamBaseService<IndyWindData[], IndyWindData> {
  protected getStreamHistoryRequest(): Promise<IndyWindData[]> {
    return axiosConfig(ApiRequestType.StreamMetricsApi)
      .post('/rest/backfill/indyWind', this.request)
      .then((response) => response.data as IndyWindData[])
      .catch(() => []);
  }

  protected onDataCallback = async (response: IndyWindData) => {
    if (this.listeners.size > 0) {
      this.localCache = [response, ...this.localCache];
      this.listeners.forEach((listener) => listener(this.localCache)); // no delay means we have to set directly
    }
  };
}

export const indyWindRsocketService = new IndyWindServiceRSocket({
  route: 'stream.indyWind',
  connectionType: StreamRequestType.MotorsportsStreamApi,
  originType: OriginType.WEATHER_STATION,
  sanctioningBody: SanctioningBodyEnum.INDYCAR,
});
